// @flow strict

import * as React from 'react';

type Props = {|
  shouldLoad: boolean,
  children: React.Node,
|};

/**
 * A component that will not render children until the first time shouldLoad is set to true.
 */
const Loadable = ({ shouldLoad, children }: Props) => {
  const loaded = React.useRef<boolean>(shouldLoad);

  // Capture the first time shouldLoad is set to true.
  if (shouldLoad && !loaded.current) {
    loaded.current = true;
  }

  return loaded.current ? children : null;
};

export default Loadable;
